<template>
<div id="stream">
    <modalSelf></modalSelf>
    <!-- <selfie-prompt /> -->
    <!-- <ModalFotosAluno v-if="role == 4" :fotos="fotosAluno" ref="modalFotos" /> -->
    <iframe width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0" scrolling="no"
    ref="meuIframe"
    src=""
    id="meet"
    allowfullscreen=true
    allow="microphone; display-capture"
    title="NovoCFC"></iframe>

    <video autoplay="true" id="selfie" style="display: none;"></video>
    <canvas id="snapshot" width="250" height="250" style="display: none;"></canvas>
    <!-- <button v-if="role == 4" class="btn btn-success btn-micro" style="position: absolute; bottom: 0.5em; left: 0.5em; width: 64px; height: 64px; padding: 0px;" @click="showFotos"><i class="fa fa-camera"></i></button> -->
</div>
</template>

<script>
import ModalSelf from './modal/self'
// import SelfiePrompt from './modal/SelfiePrompt'
// import ModalFotosAluno from './modal/ModalFotosAluno'
import urlApiV2 from '../../router/urlApiV2'

export default {
  name: 'stream',

    components: {
        ModalSelf
        // SelfiePrompt,
        // ModalFotosAluno
    },
    data () {
        return {
            interval: null,
            fotosAluno: [],
            role: localStorage.id_role,
        }
    },
    created() {
        this.armazenarTabId();
    },
    mounted () {
        // if(localStorage.id_role == 4) { this.getFotos() }
        if(localStorage.id_role == 3)
        {
            document.getElementById("meet").allow = 'camera; microphone; display-capture';
        }
        if(localStorage.id_role != 2)
        {
            this.photoRequest()
            this.photoCronRequest(JSON.parse(sessionStorage.getItem('agrupamento')))
            var agrupamento =  JSON.parse(sessionStorage.getItem('agrupamento'));
        }
        document.getElementById("meet").src = sessionStorage.getItem('link');
        // fotos durante a aula
        // Captura elemento de vídeo
        const video = document.querySelector('#selfie')
        // As opções abaixo são necessárias para o funcionamento correto no iOS
        video.setAttribute('autoplay', '')
        video.setAttribute('muted', '')
        video.setAttribute('playsinline', '')
        if(localStorage.id_role != 2)
        {
            if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                console.log('Navegador possui suporte')
                navigator.mediaDevices
                .getUserMedia({ video: { width: 250, height: 250, facingMode: 'user' } })
                .then((stream) => {
                    console.log(stream)
                    video.srcObject = stream
                }).catch((err) => {
                alert('MANTENHA SUA CAMERA LIGADA, CASO CONTRARIO SERÁ DESLIGADO DA SALA.');
                window.location.href = 'https://adm.novocfc.com.br/'+(agrupamento.instrutor ?   'instrutor' :   'aluno')+'/'+localStorage.schema
                })
            }else
            {
                alert('Seu navegador não possui suporte para dispositivos de mídia');
                window.location.href = 'https://adm.novocfc.com.br/'+(agrupamento.instrutor ?   'instrutor' :   'aluno')+'/'+localStorage.schema
            }
            this.interval = setInterval(() => {
                this.testCam(JSON.parse(sessionStorage.getItem('agrupamento')))
                this.self(JSON.parse(sessionStorage.getItem('agrupamento')))
            }, (8 * 60000));

        }

        window.addEventListener('message', this.getMensageFromIframe);
    },
    methods: {
        getMensageFromIframe(event) {
            if (event.source === this.$refs.meuIframe.contentWindow) {
                if (event.data === 'UsuárioDesconectado') {
                    if(localStorage.id_role == 2)
                    {
                        window.location.href = 'https://adm.novocfc.com.br/monitoramento/turmas-teoricas';
                        return
                    }
                    window.location.href = 'https://adm.novocfc.com.br/'+(JSON.parse(sessionStorage.getItem('agrupamento')).instrutor ?   'admin/turmas' :   'candidato/aulas-teoricas')
                }
            }
        },
        async self(agrupamento){
            if(!localStorage.getItem('id'))
            {
                alert('Você foi desconectado, por favor conecte novamente!');
                window.location.href = 'https://adm.novocfc.com.br/'+localStorage.schema
            }
            var video = document.querySelector('#selfie')
            var canvas = document.getElementById("snapshot");
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, 250, 250);
            ctx.drawImage(video, 0, 0, 250, 250);

            fetch(process.env.VUE_APP_URL_API+'/ead/foto', {
                method: "POST",
                headers: {
                            "Content-Type": "application/json",
                },
                body: JSON.stringify({
                            tempo: '',
                            turma: agrupamento.agrupamento, //id_agrupamento
                            image: canvas.toDataURL(),
                            entidade: Number(localStorage.id_role) === 3 ? 'INSTRUTOR' : 'ALUNO',
                            id: localStorage.id,
                            schema: localStorage.schema,
                }),
            })
            .then(response => response.json())
            .then((response) => {
                if (response.ok) {
                    console.log(response)
                    // this.getFotos()
                }
                throw new Error(response.body.message);
            })
            .catch((error) => {
                console.log(error)
            });
        },
        armazenarTabId() {
            if (typeof (Storage) !== "undefined") {
                if (sessionStorage["tabGUID"] == null) sessionStorage["tabGUID"] = this.construirTabId();
                var guid = sessionStorage["tabGUID"];
                window.addEventListener("storage", this.triggerRedirecionamento, false);
                localStorage["tabGUID"] = guid;
            }
        },
        triggerRedirecionamento(e) {
            console.log(e)
            if (e.key == 'tabGUID') {
                if (e.oldValue != e.newValue) {
                    window.location.href = '/candidato/aulas'
                }
            }
        },
        construirTabId() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        },
        getFotos() {
            if(localStorage.id_role != 4) return;
            this.$http.get(urlApiV2 + '/aulas/teoricas/fotos/aluno', { params: { aluno: JSON.parse(localStorage.getItem('aluno')).id_aluno, turma: JSON.parse(sessionStorage.getItem('agrupamento')).agrupamento, schema: localStorage.cfc }})
            .then(response => {
                this.fotosAluno = response.data.dados
            })
        },
        showFotos() {
            this.$refs.modalFotos.mostrarFotos()
        },
        testCam(agrupamento) {
            if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                console.log('Navegador possui suporte')
                navigator.mediaDevices
                .getUserMedia({ video: { width: 250, height: 250, facingMode: 'user' } })
                .then((stream) => {
                console.log(stream)
                }).catch((err) => {
                alert('MANTENHA SUA CAMERA LIGADA, CASO CONTRARIO SERÁ DESLIGADO DA SALA.');
                window.location.href = 'https://adm.novocfc.com.br/'+(agrupamento.instrutor ?   'instrutor' :   'aluno')+'/'+localStorage.schema
                })
            }else
            {
                alert('Seu navegador não possui suporte para dispositivos de mídia');
                window.location.href = 'https://adm.novocfc.com.br/'+(agrupamento.instrutor ?   'instrutor' :   'aluno')+'/'+localStorage.schema
            }
        },
        photoRequest() {
            Echo.private(`App.Models.Usuarios.${JSON.parse(localStorage.getItem('usuario')).id_usuario}`).listen('.GetSelfieByCandidate', (e) => {
				        this.testCam(JSON.parse(sessionStorage.getItem('agrupamento')))
                this.self(JSON.parse(sessionStorage.getItem('agrupamento')))
            })
        },
        photoCronRequest(agrupamento) {
            Echo.private(`App.Models.TurmasTeoricas.${agrupamento.agrupamento}`).listen('.GetSelfieByGroup', (e) => {
				        this.testCam(agrupamento)
                // tempo aleatório de 30 à 90 segundos
                setTimeout(() => this.self(agrupamento), Math.floor(Math.random() * 60000) + 30000);
            })
        }
    },
    beforeDestroy () {
        clearTimeout(this.interval)
        Echo.leave(`App.Models.TurmasTeoricas.${JSON.parse(sessionStorage.getItem('agrupamento')).agrupamento}`)
        Echo.leave(`App.Models.Usuarios.${JSON.parse(localStorage.getItem('usuario')).id_usuario}`)

        window.removeEventListener('message', this.getMensageFromIframe);
    }
}
</script>

<style type="text/css">
    iframe {margin:0; padding:0; height:100vh}
    iframe {display:block; width:100%; border:none}
</style>
